import * as o from "react";
import i from "../lib/IconBase.es.js";
import n from "../defs/ArrowLineRight.es.js";
const r = o.forwardRef((e, t) => /* @__PURE__ */ o.createElement(i, { ref: t, ...e, weights: n }));
r.displayName = "ArrowLineRightIcon";
const c = r;
export {
  c as ArrowLineRight,
  r as ArrowLineRightIcon
};
